import "./chunk-PXG64RU4.js"; // src/thenable.ts

import { noop } from "./utils.js";

function pendingThenable() {
  var resolve;
  var reject;
  var thenable = new Promise(function (_resolve, _reject) {
    resolve = _resolve;
    reject = _reject;
  });
  thenable.status = "pending";
  thenable.catch(function () {});

  function finalize(data) {
    Object.assign(thenable, data);
    delete thenable.resolve;
    delete thenable.reject;
  }

  thenable.resolve = function (value) {
    finalize({
      status: "fulfilled",
      value: value
    });
    resolve(value);
  };

  thenable.reject = function (reason) {
    finalize({
      status: "rejected",
      reason: reason
    });
    reject(reason);
  };

  return thenable;
}

function tryResolveSync(promise) {
  var _a;

  var data;
  (_a = promise.then(function (result) {
    data = result;
    return result;
  })) == null ? void 0 : _a.catch(noop);

  if (data !== void 0) {
    return {
      data: data
    };
  }

  return void 0;
}

export { pendingThenable, tryResolveSync };